/**
 * Movement
 */
export class Movement {
  /**
   * Movement id
   */
  movementId: number;

  /**
   * Created at
   */
  createdAt: Date;

  /**
   * Client id
   */
  clientId: number;

  /**
   * Visit
   */
  visitId: number;

  /**
   * Door
   */
  door: string;

  /**
   * Direction
   */
  direction: string;

  /**
   * Car plate assigned
   */
  carPlateAssigned: string;

  /**
   * Result
   */
  result: number;

  /**
   * Opening
   */
  opening: number;

  /**
   * Client name
   */
  clientName: string;

  /**
   * Owner
   */
  owner: string;

  /**
   * Visitor
   */
  visitor: string;

  get unifiedName() {
    if (this.clientId === 0) {
      return this.owner;
    } else if (this.clientId !== -1) {
      return this.clientName;
    } else if (this.visitId !== -1) {
      return this.visitor;
    }
  }

  get icon() {
    if (this.clientId === 0) {
      return 'assignment_turned_in';
    } else if (this.clientId !== -1) {
      return 'book_online';
    } else if (this.visitId !== -1) {
      return 'alarm';
    } else {
      return 'local_shipping';
    } 
  }

  /**
   * Create
   *
   * @param jsonData Json data
   *
   * @returns Movement
   */
  public static create(jsonData?) {
    const self = new Movement();
    Object.keys(jsonData).forEach((key) => {
      self[key] = jsonData[key];
    });
    return self;
  }
}
